// components/auth/FeatureFlagGuard.tsx
/**
 * Route guard for a page that ships dark behind an account feature flag:
 * flag off redirects to `/` (LandingRedirect), exactly like a hidden menu in
 * `MenuGuard`. Use it for pages that have no nav item yet; a page with one
 * gates the item through `SectionSubNav`'s `featureFlag` as well.
 *
 * Presentation only, like `useFeatureFlag`: the backend's own flag check is
 * what keeps the data unreachable.
 */

import { Navigate } from "@/routing/accountRouting";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";

type Props = {
  flag: string;
  children: React.ReactNode;
};

export function FeatureFlagGuard({ flag, children }: Props) {
  const enabled = useFeatureFlag(flag);
  if (!enabled) return <Navigate to="/" replace />;
  return <>{children}</>;
}
